const state = {
  groups: {
    data: [],
  },
  batchResumes: {
    id: '',
    data: [],
  },
  availableConsultations: [],
  availableTemplates: [],
  documents: [],
  templates: [],
};

export default state;
